import { OrderEligibilityDisplayService, ItemEligibilityDto, PolicyEvaluation } from '../../order-eligibility-display.service';

import PolicyItem from './policy-item';

interface PolicyItemsListProps {
    items: ItemEligibilityDto[];
    policy: PolicyEvaluation;
}

const PolicyItemsList: React.FC<PolicyItemsListProps> = ({ items, policy }) => {
    // Get items that have this policy using service
    const itemsWithPolicy = OrderEligibilityDisplayService.getItemsWithPolicy(items, policy.policy_id);

    return (
        <div className="policy-items-list">
            {itemsWithPolicy.map((item) => (
                <PolicyItem 
                    key={item.line_item_id} 
                    item={item} 
                    policy={policy} 
                />
            ))}
        </div>
    );
};

export default PolicyItemsList;
